module.exports = __webpack_public_path__ + "img/9.b93969e5.png";